import React, { createContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

// Create Context
export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const { user } = useAuth();
  const userId = user?.uid || "guest";
  const storageKey = `watchlist_${userId}`;
  const [watchlist, setWatchlist] = useState([]);

  // ✅ Load watchlist when user changes
  useEffect(() => {
    const stored = localStorage.getItem(storageKey);
    setWatchlist(stored ? JSON.parse(stored) : []);
  }, [storageKey]); // ✅ use storageKey instead of userId

  // ✅ Save watchlist to storage when it changes
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(watchlist));
  }, [watchlist, storageKey]); // ✅ use storageKey

  const resetWatchlist = () => {
  setWatchlist([]); // clear local state
};
  const addToWatchlist = (movie) => {
    const isExist = watchlist.some((m) => m.id === movie.id);
    if (!isExist) {
      setWatchlist([...watchlist, movie]);
    }
  };

  const removeFromWatchlist = (id) => {
    setWatchlist(watchlist.filter((m) => m.id !== id));
  };

  return (
    <GlobalContext.Provider value={{ watchlist, addToWatchlist, removeFromWatchlist,resetWatchlist }}>
      {children}
    </GlobalContext.Provider>
  );
};
